module.exports = __webpack_public_path__ + "static/Picture-1-2685c6953e7379e57fae36ee1343b688.jpg";